import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import {
  MotorDataDataService,
  SubmitApplicationRequest
} from "src/app/share/data-service/motor.data.service";
import { AlertService } from "src/app/share/service/alert.service";

@Component({
  selector: "app-reject-application",
  templateUrl: "./reject-application.component.html",
  styleUrls: ["./reject-application.component.scss"]
})
export class RejectApplicationComponent implements OnInit, OnDestroy {
  form: FormGroup;
  subscription: Subscription;

  rejectTypeList: string[] = ["Tidak diterima oleh pihak KOPETRO"];
  rejectReasonList: string[] = [
    "Tidak cukup syarat kelayakan (syer min RM1k)",
    "Tiada maklum balas daripada anggota dalam masa 14 hari",
    "Anggota mohon untuk pembatalan",
    "Lain-lain"
  ];

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<RejectApplicationComponent>,
    private ngxSpinnerService: NgxSpinnerService,
    private alertService: AlertService,
    private motorDataDataService: MotorDataDataService,
    @Inject(MAT_DIALOG_DATA) private data: { id: string }
  ) {
    this.createForm();
    this.listenChanges();
  }

  ngOnInit(): void {
    this.form.get("rejectType").patchValue(this.rejectTypeList[0]);
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      rejectType: [null, Validators.required],
      rejectReason: [null, Validators.required],
      remarks: [null]
    });
  }

  listenChanges(): void {
    this.subscription = this.form
      .get("rejectReason")
      .valueChanges.subscribe((value) => {
        const remarks = this.form.get("remarks");

        if (value === "Lain-lain") {
          remarks.setValidators(Validators.required);
        } else {
          remarks.clearValidators();
        }

        remarks.reset();
        remarks.updateValueAndValidity();
      });
  }

  onSubmit(): void {
    if (this.form.invalid) return;

    this.ngxSpinnerService.show();

    const form: FormData = this.form.getRawValue();

    let request: SubmitApplicationRequest = {
      id: this.data.id,
      actionType: "reject",
      rejectType: form.rejectType,
      rejectReason: form.rejectReason,
      remarks: form.remarks
    };

    try {
      this.motorDataDataService.submitApplication(request).subscribe({
        next: () => {
          this.ngxSpinnerService.hide();
          this.dialogRef.close(true);
        },
        error: () => {
          this.ngxSpinnerService.hide();
          this.alertService.openSnackBar("Failed to submit application");
        }
      });
    } catch (error) {
      this.ngxSpinnerService.hide();
    }
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}

interface FormData {
  rejectType: string;
  rejectReason: string;
  remarks: string;
}
